var _circle, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStaffSales(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.9297,
    cy: 20,
    r: 20,
    fill: "#DDEEF8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0637 6.29333L10.2637 11.3731V27.9729H18.2637V19.1729H23.8637V11.3731L17.0637 6.29333ZM17.0637 10.3733C16.6237 10.3733 16.2637 10.0133 16.2637 9.57334C16.2637 9.13334 16.6237 8.77334 17.0637 8.77334C17.5037 8.77334 17.8637 9.13334 17.8637 9.57334C17.8637 10.0133 17.5037 10.3733 17.0637 10.3733Z",
    fill: "#49B7E4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0645 19.9734V30.3734H34.2645V19.9734H19.0645ZM32.6645 27.1734H32.2645C31.5845 27.1734 31.0645 27.6934 31.0645 28.3734V28.7734H22.2645V28.3734C22.2645 27.6934 21.7445 27.1734 21.0645 27.1734H20.6645V23.1734H21.0645C21.7445 23.1734 22.2645 22.6534 22.2645 21.9734V21.5734H31.0645V21.9734C31.0645 22.6534 31.5845 23.1734 32.2645 23.1734H32.6645V27.1734Z",
    fill: "#49B7E4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3048 22.3733H23.0248C22.8648 23.1733 22.2648 23.7733 21.4648 23.9333V26.4133C22.2648 26.5733 22.8648 27.1733 23.0248 27.9733H30.3048C30.4648 27.1733 31.0648 26.5733 31.8648 26.4133V23.9333C31.0648 23.7733 30.4648 23.1733 30.3048 22.3733ZM26.6648 26.3733C25.9848 26.3733 25.4648 25.8533 25.4648 25.1733C25.4648 24.4933 25.9848 23.9733 26.6648 23.9733C27.3448 23.9733 27.8648 24.4933 27.8648 25.1733C27.8648 25.8533 27.3448 26.3733 26.6648 26.3733Z",
    fill: "#49B7E4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaffSales);
export default __webpack_public_path__ + "static/media/staff-sales.bba9bfc5794d712200069389cad40b07.svg";
export { ForwardRef as ReactComponent };